import styled from "styled-components";

export const List = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Text = styled.p`
  font-size: 20px;
  color:rgb(140, 158, 167);
  display: flex;
  justify-content: center;
  padding: 32px;
`;
